import { get, post } from "../services/HttpService";
import { urlValidationRegex } from "../app_methods";

export class WebhookConfigurationModel {
  static validations = {
    webhook_url: (required) => {
      return [
        {
          required,
          message: "Webhook url is required.",
        },
        {
          validator: (rule, value, callback) => this.webhookUrlValidator(rule, value, callback, required),
        },
      ];
    },
    max_attempts: (required) => {
      return [
        {
          required,
          message: "Max attempts required.",
        },
        {
          validator: (rule, value, callback) => this.webhookMaxAttemptsvalidator(rule, value, callback, required),
        },
      ];
    },
    interval_value: (required, unit) => {
      return [
        {
          required,
          message: "Interval value for max attempts required.",
        },
        {
          validator: (rule, value, callback) => this.attemptIntervalValidator(rule, value, callback, required, unit),
        },
      ];
    },
    interval_unit: (required) => {
      return [
        {
          required,
          message: "Interval unit required.",
        },
        {
          validator: (rule, value, callback) => this.attemptIntervalUnitValidator(rule, value, callback, required),
        },
      ];
    },
  };

  static getWebhookConfiguration = (isInsta = false, queryData = {}) => {
    const url = isInsta ? `v1/insta-collect/internal/webhook/` : `v1/internal/webhook/`;
    return get(url, queryData, {});
  };

  static postWebhookConfiguration = (isInsta = false, queryData = {}) => {
    const url = isInsta ? `v1/insta-collect/internal/webhook/update/` : `v1/internal/webhook/update/`;
    return post(url, queryData, {});
  };
  
  static testWebhook = (isInsta = false, queryData = {}) => {
    const url = isInsta ? `v1/insta-collect/internal/webhook/test_webhook/` : `v1/internal/webhook/test_webhook/`;
    return post(url, queryData, {});
  };

  static webhookMaxAttemptsvalidator = (_rule, value, callback, required) => {
    if (!value) return callback();
    const regex = /^[1-9][0-9]*$/;
    if (!regex.test(value)) {
      callback("Invalid input");
    } else if (value < 2 || value > 9) {
      callback("Max attempts must be between 2 to 9");
    } else {
      callback();
    }
  };

  static webhookUrlValidator = (_rule, value, callback, required) => {
    if (!required || !value) return callback();
    const regex = urlValidationRegex();
    if (!regex.test(value)) {
      callback("Invalid input");
    } else {
      callback();
    }
  };

  static attemptIntervalValidator = (_rule, value, callback, required, unit) => {
    if (!required || !value) return callback();

    // check for valid input
    const regex = /^[1-9][0-9]*$/;

    if (!regex.test(value)) {
      return callback("Invalid input");
    } else if (!unit) {
      return callback("Units required input.");
    } else if (value > maxVals[unit]) {
      callback(`Max ${maxVals[unit]} ${unit} are allowed`);
    } else {
      callback();
    }
  };

  static attemptIntervalUnitValidator = (_rule, value, callback, required) => {
    if (!required || !value) return callback();
    console.log("interval_unit", required , value);
    if (!value) {
      return callback("Units required input.");
    } else {
      callback();
    }
  };
}

export const maxVals = {
  minutes: 60,
  hours: 24,
};

export const minutesInUnit = {
  days: 1440,
  hours: 60,
  minutes: 1,
};
